module.exports = __webpack_public_path__ + "static/media/utxo-wallet.387686c5.png";